// Constants
import {
  APPLE_APP_STORE_URL,
  GOOGLE_PLAY_STORE_URL,
} from 'constants/external-links';
// Helpers
import {
  clearCreatorSignUpFlowLocalStorageFlag,
  getCreatorSignUpFlowLocalStorageFlag,
} from 'helpers/storage';
import { isAndroidUserAgent, isMobileUserAgent } from 'helpers/userAgent';
import { openStoreOrAppUrl } from 'helpers/openAppUrl';

// `openStoreOrAppUrl`'s second argument: true navigates the current tab
// (vs. opening a new one) - see helpers/openAppUrl.ts.
const OPEN_IN_SAME_TAB = true;

/**
 * Call once the creator account is created. Consumes the /creator-signup flag
 * and returns whether to send the user straight to the app store (mobile only,
 * and never over the ext-talent brand-deal flow, which routes elsewhere).
 */
export const finishCreatorSignUpFlow = (isExtTalentFlow: boolean): boolean => {
  const fromCreatorSignUp = Boolean(getCreatorSignUpFlowLocalStorageFlag());
  if (fromCreatorSignUp) clearCreatorSignUpFlowLocalStorageFlag();
  return fromCreatorSignUp && !isExtTalentFlow && isMobileUserAgent();
};

export const redirectToAppStore = (): void =>
  openStoreOrAppUrl(
    isAndroidUserAgent() ? GOOGLE_PLAY_STORE_URL : APPLE_APP_STORE_URL,
    OPEN_IN_SAME_TAB
  );
